import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ckeditor = _resolveComponent("ckeditor");
  return _openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([$options.cssProps, {
      "height": "calc(100% - 210px)"
    }])
  }, [_createVNode(_component_ckeditor, {
    editor: $data.editorType,
    modelValue: $options.body,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $options.body = $event;
    }),
    config: $data.editorConfig,
    onReady: $options.onEditorReady,
    onFocus: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('focused');
    }),
    onBlur: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.$emit('blurred');
    })
  }, null, 8, ["editor", "modelValue", "config", "onReady"])], 4);
}